import React, { useState } from 'react';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('tr');
  
  const languages = {
    tr: {
      name: 'Türkçe',
      flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAMAAABBPP0LAAAARVBMVEX+AAD3AADwAAD+fHz9cHH7ZGT9WVn6UFDpAAD9oKD5Q0P5OTn2MzP1Kir7ubr65ub1Gxv69PTzDw/kAAD319ffAAD4iooXHQ3FAAAAYklEQVR4AT3HhW0EQRQD0Oc/KG3/dQYEYTg2O+4IQbTHydWt0fw2Sfz8Fuw51+U3On7a6/pc/as1UZLDyuq13lWOwpdPn3+v7XJiDD3DR1N87Qr5WXX9zyQ9opEIOwkmDgr/ZXASmpFRqe0AAAAASUVORK5CYII='
    },
    en: {
      name: 'English',
      flag: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAMAAABBPP0LAAAAmVBMVEViZsViZMJiYrf9gnL8eWrlYkjgYkjZYkj8/PujwPybvPz4+PetraBEgfo+fvo3efkydfkqcvj8Y2T8UlL8Q0P8MzP9k4Hz8/Lu7u4DdPj9/VrKysI9fPoDc/EAZ7z7IiLHYkjp6ekCcOTk5OIASbfY/v21takAJrT5Dg6sYkjc3Nn94t2RkYD+y8KeYkjs/v7l5fz0dF22YkjWvcOLAAAAgElEQVR4AR2KNULFQBgGZ5J13KGGKvc/Cw1uPe62eb9+Jr1EUBFHSgxxjP2Eca6AfUSfVlUfBvm1Ui1bqafctqMndNkXpb01h5TLx4b6TIXgwOCHfjv+/Pz+5vPRw7txGWT2h6yO0/GaYltIp5PT1dEpLNPL/SdWjYjAAZtvRPgHJX4Xio+DSrkAAAAASUVORK5CYII='
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    setIsOpen(false);
    // Here you would implement the actual language change functionality
    // This could involve changing routes or setting a language context
  };

  return (
    <li className="pll-parent-menu-item menu-item dropdown nav-item">
      <a 
        className="nav-link dropdown-toggle" 
        href="#pll_switcher" 
        data-toggle="dropdown"
        onClick={toggleDropdown}
      >
        <img 
          src={languages[currentLanguage].flag} 
          alt="" 
          width="16" 
          height="11" 
          style={{ width: '16px', height: '11px' }} 
        />
        <span style={{ marginLeft: '0.3em' }}>{languages[currentLanguage].name}</span>
      </a>
      <ul className={`dropdown-menu depth_0 ${isOpen ? 'show' : ''}`}>
        {Object.keys(languages).map(lang => (
          <li 
            key={lang} 
            className={`lang-item lang-item-${lang} ${currentLanguage === lang ? 'current-lang' : ''} menu-item dropdown-item`}
          >
            <a onClick={() => changeLanguage(lang)} href={`#${lang}`}>
              <img 
                src={languages[lang].flag} 
                alt="" 
                width="16" 
                height="11" 
                style={{ width: '16px', height: '11px' }} 
              />
              <span style={{ marginLeft: '0.3em' }}>{languages[lang].name}</span>
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default LanguageSwitcher;